import { LocalComponent } from "~/ecs/base"

export class Clicked extends LocalComponent {}
